import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useFinance } from "../FinanceContext";
import { CUR_MONTH_IDX, MONTHS } from "../data/seedData";

/** Compact "reporting month" <select> — reused inline in page toolbars. */
export function MonthInline() {
  const { selMonth, setSelMonth } = useFinance();
  return (
    <TextField
      select
      size="small"
      value={selMonth}
      label="Reporting month"
      onChange={(e) => setSelMonth(Number(e.target.value))}
      sx={{ minWidth: 170 }}
    >
      {MONTHS.map((m, i) => (
        <MenuItem key={m} value={i}>
          {m}
          {i === CUR_MONTH_IDX ? " (current)" : ""}
        </MenuItem>
      ))}
    </TextField>
  );
}

/** Row with a "Reporting month:" label + the month select — used at the top of several pages. */
export function MonthPickerRow() {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1.5 }}>
      <Typography variant="body2" color="text.secondary">
        Reporting month:
      </Typography>
      <MonthInline />
    </Box>
  );
}
